import doesActiveExperiencesInclude from "./doesActiveExperiencesInclude";
import type { MailboxInfo } from "owa-client-types";

/**
 * Checks to see if the user has Teams Premium Intelligent license
 * @returns true if the user has Teams Premium Intelligent license
 */
export default function isTeamsProManagementUser(mailboxInfo?: MailboxInfo): boolean {
    return doesActiveExperiencesInclude("TeamsProManagement", mailboxInfo);
}
